import React, { ReactNode } from "react";
import { Row, Col } from "antd";
import { Gutter } from "antd/lib/grid/row";

export type GutterSize = "sm" | "md" | "lg";

type Props = {
  header?: () => ReactNode;
  /**
   * Set the size of the horizontal and vertical gutters.
   * @default md
   */
  gutters?: GutterSize;
  block?: boolean;
};

export const PageSection: React.FC<Props> = ({
  children,
  header,
  gutters,
  block,
}) => {
  /**
   * Maps the gutter props size to Antd gutters
   */
  const getGutterSize = (): [Gutter, Gutter] => {
    let v = 0;
    switch (gutters) {
      case "sm":
        v = 24;
        break;
      case "md":
        v = 48;
        break;
      case "lg":
        v = 72;
        break;
      default:
        return [0, 0];
    }
    return [v, v];
  };

  return (
    <Row gutter={getGutterSize()}>
      <Col xs={{ span: 24 }} lg={{ span: block ? 24 : 16 }}>
        {header ? header() : null}
        {children}
      </Col>
    </Row>
  );
};

PageSection.defaultProps = {
  gutters: "md",
};
